import React from 'react'

function FAQs() {
  return (
    <div>s</div>
  )
}

export default FAQs